@let callUsage = callUsage$ | async;
<div class="voice-usage-container">
  <div [class]="!callUsage ? 'hide-text' : ''">
    {{
      'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.VOICE_RECEPTIONIST.MINUTES_USED'
        | translate
          : {
              used: callUsage?.totalMinutes || 0,
              limit: callUsageLimitMinutes,
            }
    }}
  </div>
  <glxy-progress-bar [progress]="callUsage?.limitPercent || 0" [isLoading]="!callUsage" />
  <div [class]="!callUsage ? 'hide-text' : ''" class="voice-usage-range">
    {{
      'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.VOICE_RECEPTIONIST.USAGE_PROGRESS'
        | translate
          : {
              startDay: callUsage?.startDate | date: 'MMM d' : 'UTC',
              endDay: callUsage?.endDate | date: 'MMM d' : 'UTC',
            }
    }}
  </div>
  <div class="stencil-shimmer bottom"></div>
</div>
